import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { resetCart } from "../../redux/cartReducer";
import { message, Spin } from "antd";
import { useAuthContext } from "../../context/AuthContext";
import { Link, useNavigate } from 'react-router-dom';
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { getToken } from "../../helpers";

const Checkout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useAuthContext();
  const [Address, setAddress] = useState("");
  const [PaymentType, setPaymentType] = useState("");
  const products = useSelector((state) => state.cart.products);
  const API = process.env.REACT_APP_API_URL;
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  const { data } = useFetch(`/user-addresses?populate=*`, getToken());

  const totalPrice = () => {
    let total = 0;
    products.forEach((item) => {
      total += item.quantity * item.price;
    });
    return total.toFixed(2);
  };

  const handlePayment = async () => {
    if (Address === "" || PaymentType === "") {
      message.error("Please Select Address and Payment Type before proceed");
      return;
    }
    let value = {
      products: JSON.stringify(products),
      user_address: Address,
      users_permissions_user: user.id,
      orderPaymentType: PaymentType,
      TotalPrice: totalPrice(),
      shipping_charges: 99,
      OrderStatus: "Pending",
      PaymentDetails: JSON.stringify({})
    };
    setLoadingUpdate(true);
    try {
      let fURL = `${API}/orders`;
      const response = await fetch(fURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // set the auth token to the user's jwt
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({data: value}),
      });
      const responseData = await response.json();
      //console.log(responseData);
      if(responseData.error) {
        message.error("Error While Creating Order!");
      } else {
        dispatch(resetCart());
        message.success("Order created successfully!");
        navigate("/profile", { replace: true });
      }
    } catch (error) {
      console.error(Error);
      message.error("Error While Updating/Creating the Address!");
    } finally {
      setLoadingUpdate(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row text-end">
        <h4>Welcome {user?.full_name}, </h4>
      </div>
      <div className="row">
        <h4>Delivery Address&nbsp;
          <Link className ="link" to="/user-addresses/create?ref=checkout">
            Add Address
          </Link>
        </h4>
        <div className="row">
          <div className="col-md-8">
            {data?.map((item) => <div className="row" key={item.id}>
              <div className="card-body">
                <input type="radio" value={item.id} name="price"
                  onChange={(e) => setAddress(item.id)} />
                <span className="ps-3">
                  Address Type : {item?.address_type}<br/>{item?.address1} {item?.address2}<br/>
                  {item?.city}, {item?.state} {item?.pincode}
                </span>
              </div>
            </div>)}
            <h4>Payment Type</h4>
            <ul className="filter list-unstyled ps-3">
              <li><input type="radio" value="CashOnDelivery" name="paymentType"
                onChange={(e) => setPaymentType("CashOnDelivery")} />
                <label className="ps-3" htmlFor="CashOnDelivery">Cash On Delivery</label></li>
            </ul>
          </div>
          <div className="col-md-4">
            <h4>Products in your cart</h4>
            {products?.map((item) => (
              <div className="row mb-3" key={item.id}>
                <div className="col-md-4"><img style={{height: "50px"}} src={process.env.REACT_APP_UPLOAD_URL + item.img} alt="" /></div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h4>{item.title}</h4>
                    <p className="text-center mb-0">
                      {item.quantity} x ₹{item.price}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            <div className="row">
              <div className="col-lg-6 text-end">TOTAL : </div>
              <div className="col-lg-6 text-end">₹{totalPrice()}</div>
            </div>
            <div className="row">
              <div className="col-lg-6 text-end">Shipping : </div>
              <div className="col-lg-6 text-end">₹99.00</div>
            </div>
            <div className="row mb-4">
              <div className="col-lg-6 text-end">Grand Total : </div>
              <div className="col-lg-6 text-end">₹{(parseFloat(totalPrice()) + 99).toFixed(2)}</div>
            </div>
            <div className="col d-grid"><button className="btn btn-success btn-lg" onClick={handlePayment}>
              {loadingUpdate ? (
                <>
                  <Spin size="small" /> Saving
                </>
              ) : (
                "BUY NOW"
              )}</button></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;